import Article from './entities/article';
import BreadcrumbList from './entities/breadcrumb-list';
import Event from './entities/event';
import FaqPage from './entities/faq-page';
import HowTo from './entities/how-to';
import Person from './entities/person';

const LdJson = (pageProps, entities) => {
  const entity = entities;
  const entityName = Object.keys(entities)[0];
  let tag;

  switch (entityName) {
    case 'Article':
      tag = Article(pageProps);
      break;
    case 'BreadcrumbList':
      tag = BreadcrumbList(entity.BreadcrumbList);
      break;
    case 'Event':
      tag = Event(pageProps);
      break;
    case 'FaqPage':
      tag = FaqPage(entity.FaqPage);
      break;
    case 'HowTo':
      tag = HowTo(entity.HowTo);
      break;
    case 'Person':
      tag = Person({ ...entity.Person, page: { ...pageProps } });
      break;
    default:
      tag = null;
      break;
  }

  return tag
    ? `
{
  "@context": "https://schema.org",
  "@graph": [
    ${tag}
  ]
}
`
    : '';
};

export default LdJson;
